module.exports = __webpack_public_path__ + "img/GAME_QUIZ2.2c501ed4.jpg";